import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';
import { AccessReviewParameters, ReviewQueryParameters } from '@mvrb-frontend/shared-ui';
import moment from 'moment';

export const useGetReview = () => {
  const [isFetching, setFetching] = useState(false);

  return {
    isFetching,
    getReview: async (id, queryparams?: ReviewQueryParameters) => {
      try {
        setFetching(true);
        const response = await AxiosPublic.get(`/reviews/${id}`, {
          params: queryparams,
        });
        return response;
      } catch (e) {
        throw e;
      } finally {
        setFetching(false);
      }
    },
    getReviewAcces: async (queryparams: AccessReviewParameters) => {
      try {
        const response = await AxiosPublic.get('/reviews/userReview/access', {
          params: queryparams,
        });
        return response;
      } catch (e) {
        throw e;
      }
    },
    postEditHistory: async (id, queryparams?: any, EditedAt?: any) => {
      const currentDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
      try {
        const response = await AxiosPublic.post(`/reviews/${id}/edit`, {
          params: queryparams,
          currentDate: EditedAt,
        });
        return;
      } catch (e) {
        throw e;
      }
    },
  };
};
